import { Link, useNavigate } from 'react-router-dom';
import WelcomeEditionScroller from '../../components/marketing/WelcomeEditionScroller.jsx';
import { markWelcomeSeen } from '../../lib/firstVisit.js';

// Unauthenticated landing page. Rendered standalone (outside AppLayout) so the
// hero takeover isn't broken up by the site header/footer.
export default function WelcomeLanding({ onDismiss }) {
  const navigate = useNavigate();

  const dismissWelcome = () => {
    markWelcomeSeen();
    onDismiss?.();
  };

  const proceedToBrief = () => {
    dismissWelcome();
    navigate('/today', { replace: true });
  };

  const goSubscribe = () => {
    dismissWelcome();
    navigate('/signup');
  };

  return (
    <div className="welcome-landing h-dvh max-h-dvh flex flex-col overflow-hidden">
      <div className="relative shrink-0 py-2.5 px-4 sm:px-8 text-center border-b-2 border-hxd-orange flex items-center justify-center gap-4">
        <button
          type="button"
          onClick={proceedToBrief}
          className="text-[15px] text-white/60 hover:text-white bg-transparent border-0 cursor-pointer font-sans p-0"
        >
          Proceed to{' '}
          <span className="font-semibold text-hxd-orange underline underline-offset-2">
            Today&apos;s Brief
          </span>
        </button>
      </div>

      <div className="flex-1 min-h-0 flex flex-row overflow-hidden">
        <section className="w-[50%] sm:w-[48%] lg:w-[52%] shrink-0 flex items-center pl-6 sm:pl-10 lg:pl-12 pr-4 sm:pr-6 overflow-hidden">
          <div className="w-full max-w-[560px] flex flex-col items-start text-left">
            <img
              src="/images/hxd-logo-white.png"
              alt="Hangar X Daily"
              width={1024}
              height={320}
              className="mb-6 w-[min(100%,320px)] h-auto block"
            />

            <h1 className="font-sans text-[clamp(1.5rem,2.8vw,2.125rem)] font-bold text-white leading-snug m-0">
              Aviation &amp; AAM intelligence in five minutes
            </h1>
            <p className="mt-4 text-[16px] sm:text-[18px] leading-relaxed text-white/85 m-0">
              Join operators, investors, and builders who start weekdays with editor-curated
              eVTOL, defense aviation, and advanced air mobility coverage.
            </p>

            <button type="button" onClick={goSubscribe} className="home-hero-cta">
              Subscribe
            </button>

            <p className="mt-3 text-[12px] sm:text-[13px] text-white/50 m-0">
              By subscribing, you accept our{' '}
              <Link
                to="/signup"
                onClick={dismissWelcome}
                className="text-white/65 font-semibold underline hover:text-white"
              >
                account terms
              </Link>
              . Unsubscribe anytime.
            </p>
          </div>
        </section>

        <div className="flex-1 min-w-0 min-h-0 overflow-hidden">
          <WelcomeEditionScroller />
        </div>
      </div>
    </div>
  );
}
